import { createAction } from '@reduxjs/toolkit';
import { LOCALE_FIN } from '@/lib/helpers';
import { fetchSalesOrder } from '@/lib/redux/redux-actions';
import { api } from '@/lib/trpc/client';
import type { AppDispatch, RootState } from '@/app/store';

import type { RouterInputs } from '@/lib/trpc/react';

type ComponentInput = RouterInputs['salesOrders']['addSalesOrderDefaultComponent']['component'];
type ComponentInputWithoutChain = Omit<ComponentInput, 'chain'>;

export const salesOrdersNewDefaultComponentRequestStarted = createAction(
  'sales-orders-new-default-components/request/started'
);
export const salesOrdersNewDefaultComponentRequestFailed = createAction<string>(
  'sales-orders-new-default-components/request/failed'
);
export const salesOrdersNewDefaultComponentSucceeded = createAction(
  'sales-orders-new-default-components/post/succeeded'
);
export const salesOrdersNewDefaultComponentSetItems = createAction<ComponentInput['items']>(
  'sales-orders-new-default-components/set/items'
);
export const salesOrdersNewDefaultComponentSetDialogOpen = createAction<boolean>(
  'sales-orders-new-default-components/set/dialog-open'
);
export const setSalesOrdersNewDefaultComponentInputErrors = createAction<string[]>(
  'sales-orders-new-default-components/set/input-errors'
);

function getTrcpErrorMessage(error: any): string {
  return error?.message || error?.data?.code;
}

export const postSalesOrdersNewDefaultComponent =
  (component: ComponentInputWithoutChain) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(salesOrdersNewDefaultComponentRequestStarted());

    const state = getState();
    const userState = state.user;
    const { activeChain, user } = userState;

    const salesOrderState = state.salesOrder;
    const { salesOrder } = salesOrderState;

    return api.salesOrders.addSalesOrderDefaultComponent
      .mutate({
        component: { ...component, chain: activeChain } as ComponentInput,
      })
      .then(
        ({ status, result }) => {
          if (result) {
            if (status === 'success') {
              dispatch(salesOrdersNewDefaultComponentSucceeded());
              // re fetch
              if (salesOrder.salesOrderGroupId && salesOrder.shopId) {
                void dispatch(fetchSalesOrder(salesOrder.salesOrderGroupId, salesOrder.shopId));
              }
            } else {
              const errorKey = typeof result.error === 'string' ? result.error : '';
              const localeValue = LOCALE_FIN[`DC_ERROR_${errorKey}` as keyof typeof LOCALE_FIN];
              const defaultMessage = LOCALE_FIN.DC_ERROR_INVALID_REQUEST;
              const message = String(
                typeof localeValue === 'string' ? localeValue : defaultMessage
              );

              dispatch(salesOrdersNewDefaultComponentRequestFailed(message));
            }
          } else {
            dispatch(
              salesOrdersNewDefaultComponentRequestFailed(LOCALE_FIN.DC_ERROR_INVALID_REQUEST)
            );
          }
        },
        (error) => {
          dispatch(
            salesOrdersNewDefaultComponentRequestFailed(
              getTrcpErrorMessage(error) || LOCALE_FIN.DC_ERROR_INVALID_REQUEST
            )
          );
        }
      );
  };
